import React from "react";
import errorImage from "../../assets/images/wired-outline-1140-error.gif"
const ErrorModal = ({ isOpen, onClose, errorMessage }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Overlay */}
            <div
                className="fixed inset-0 bg-black bg-opacity-30"
                onClick={onClose} // closes modal when clicking the background
            />

            {/* Modal Content */}
            <div className="relative z-50 w-full max-w-md bg-white rounded-lg shadow-xl min-h-[250px]">
                <div className="p-8 text-center">
                    {/* Error Icon */}
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                        <img
                            src={errorImage}
                            alt="error_Img"
                            height="100px"
                            width="100px"
                        />
                    </div>

                    {/* Title */}
                    <h3 className="text-lg font-semibold mb-2 text-red-600">
                        Error!
                    </h3>

                    {/* Message */}
                    <p className="mb-6 text-sm text-gray-700">
                        {errorMessage || "An unknown error occurred."}
                    </p>

                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-[#E86B1B] text-white rounded hover:bg-[#cf5e17] text-12"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorModal;
